import { EventBroker } from "@frontend/lib/utils/event-broker";

export const VIDEO_EVENTS = {
    SHOW_FOLDERS_MODAL: 'SHOW_FOLDERS_MODAL',
    FOLDER_SELECTED: 'FOLDER_SELECTED',
};

export const videoEventBroker = new EventBroker();
